import React from "react";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import SearchInput from "components/inputs/search-input";
import { fetchPatientResults } from "app/main/patients/actions/patients.actions";
import { getPatientSearchTerms, getPageInfo } from "../reducers/patients.reducers";

class PatientsSearch extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = ({ searchParams }) => {
    const { pageInfo: { pageSize } } = this.props;
    this.props.fetchPatientResults(1, pageSize, searchParams);
  };

  render() {
    const { initialValues } = this.props;
    return (
      <Formik
        initialValues={initialValues}
        onSubmit={this.handleSubmit}
        enableReinitialize
        render={({ handleSubmit }) => (
          <Field
            name="searchParams.name"
            placeholder="Search by Name"
            component={SearchInput}
            onSearch={handleSubmit}
          />
        )}
      />
    );
  }
}

export default connect(state => ({
  pageInfo: getPageInfo(state),
  initialValues: { searchParams: getPatientSearchTerms(state) },
}), { fetchPatientResults })(PatientsSearch);
